import { Link } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';
import Reveal from './Reveal';

const FounderStory = () => (
  <section data-testid="founder-section" className="bg-black py-20 md:py-28">
    <div className="mx-auto max-w-7xl px-6 md:px-12">
      <div className="grid items-center gap-10 lg:grid-cols-12 lg:gap-16">
        <Reveal className="lg:col-span-7">
          <div className="relative overflow-hidden rounded-xl border border-white/[0.08]">
            <img
              src="/filmmaking_part.jpg"
              alt="A small crew lighting a set on a live shoot"
              loading="lazy"
              className="aspect-[16/10] w-full object-cover"
            />
            <div className="pointer-events-none absolute inset-0 bg-gradient-to-r from-black/50 via-transparent to-black/40" />
          </div>
        </Reveal>

        <Reveal delay={0.12} className="lg:col-span-5">
          <h2 className="display-heading text-3xl text-white sm:text-4xl lg:text-[2.75rem]">
            Built by a filmmaker,
            <br />
            <em>for aspiring filmmakers.</em>
          </h2>

          <p className="mt-6 max-w-md text-sm leading-relaxed text-zinc-400 md:text-base">
            Cynopsis was founded by a filmmaker and cinematographer who experienced the same
            uncertainty - and realised there must be a better, more accessible way to learn
            filmmaking.
          </p>

          <Link to="/about" className="btn-cine-outline mt-8 rounded-md">
            Know our story
            <ArrowRight className="h-4 w-4" />
          </Link>
        </Reveal>
      </div>
    </div>
  </section>
);

export default FounderStory;
